import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const ROLES = [
  { id: "seller", label: "Property Seller / Homeowner", desc: "I want to explore options for my property." },
  { id: "investor", label: "Investor / Cash Buyer", desc: "I buy properties or fund deals." },
  { id: "realtor", label: "Realtor / Agent", desc: "I represent buyers and sellers." },
  { id: "attorney", label: "Attorney", desc: "I provide legal services." },
  { id: "lender", label: "Lender / Funding Partner", desc: "I provide financing or refis." },
  { id: "contractor", label: "Contractor", desc: "I provide repair estimates and work." },
  { id: "title", label: "Title Company", desc: "I handle closings and title work." },
];

export const SITUATIONS = [
  { id: "behind_mortgage", label: "Behind on Mortgage", pill: "pill-foreclosure" },
  { id: "foreclosure", label: "Foreclosure", pill: "pill-foreclosure" },
  { id: "probate", label: "Probate", pill: "pill-probate" },
  { id: "divorce", label: "Divorce", pill: "pill-neutral" },
  { id: "tax_delinquent", label: "Tax Delinquent", pill: "pill-tax" },
  { id: "vacant", label: "Vacant Property", pill: "pill-vacant" },
  { id: "code_violations", label: "Code Violations", pill: "pill-tax" },
  { id: "needs_repairs", label: "Needs Repairs", pill: "pill-vacant" },
  { id: "inherited", label: "Inherited Property", pill: "pill-probate" },
  { id: "absentee", label: "Absentee Owner", pill: "pill-neutral" },
  { id: "need_fast_cash", label: "Need Fast Cash Offer", pill: "pill-neutral" },
  { id: "highest_buyer", label: "Want Highest Buyer", pill: "pill-neutral" },
  { id: "avoid_foreclosure", label: "Avoid Foreclosure", pill: "pill-foreclosure" },
];

export const OFFER_TYPES = [
  { id: "cash", label: "Cash Offer" },
  { id: "subject_to", label: "Subject-To" },
  { id: "seller_finance", label: "Seller Finance" },
  { id: "novation", label: "Novation" },
  { id: "listing", label: "Listing Proposal" },
  { id: "refinance", label: "Refinance Option" },
  { id: "loan_mod", label: "Loan Modification Referral" },
  { id: "contractor_estimate", label: "Contractor Repair Estimate" },
  { id: "legal_referral", label: "Legal Help Referral" },
  { id: "short_sale", label: "Short Sale Option" },
];

export const fmtUSD = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); }
  catch { return iso; }
};
